import { Injectable } from "@angular/core";
import { StatusModel } from "../model/status.model";
import { HttpClient } from "@angular/common/http";
import { FormPilaRq } from "../model/fromPilaRq";

import { ConfigService } from "./config.service";

@Injectable({
  providedIn: "root",
})
export class PilaServices {
  constructor(private http: HttpClient, private config:ConfigService) {}

  public url: string = this.config.getConfiguration().backendUrlBaseOcc;
  statusModel: StatusModel = new StatusModel();

  getInformationPila(input: FormPilaRq) {
    console.log(this.url);
    return this.http.post(
      `${this.url}/conplanServices/getInformationPILA`,
      input
    );
  }
}
